import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

interface FeedbackPageUrlContextValue {
  feedbackPageUrl: string | null
  setFeedbackPageUrl: (pageUrl: string | null) => void
}

const FeedbackPageUrlContext =
  createContext<FeedbackPageUrlContextValue | null>(null)

export function FeedbackPageUrlProvider({
  children,
}: {
  readonly children: ReactNode
}) {
  const [feedbackPageUrl, setFeedbackPageUrl] = useState<string | null>(null)

  return (
    <FeedbackPageUrlContext.Provider
      value={{
        feedbackPageUrl,
        setFeedbackPageUrl,
      }}
    >
      {children}
    </FeedbackPageUrlContext.Provider>
  )
}

export function useFeedbackPageUrl(): string | null {
  const context = useContext(FeedbackPageUrlContext)
  return context?.feedbackPageUrl ?? null
}

export function useSetFeedbackPageUrl(): (pageUrl: string | null) => void {
  const context = useContext(FeedbackPageUrlContext)
  if (context === null) {
    return () => {
      return
    }
  }

  return context.setFeedbackPageUrl
}
